'use client'

import { Base } from '@indxsearch/systm'
import styles from './CodeExample.module.css'

// icons
import {
  Csharp,
  Stop,
  Zap,
  Puzzle_piece
} from "@indxsearch/pixl";
import FeatureIcon from '../components/FeatureIcon';

export default function CodeExample() {
  return (
    <div className={styles.wrapper}>
        <div className={styles.inside}>
          <Base className={styles.base}>
              <div className={styles.baseinner}>
                  <div className={styles.title}>
                      <h2>Index and search in a few lines of C#</h2>
                      <p>Point Indx at your JSON, mark a few fields as searchable, and run your app.</p>
                      <ul>
                        <li><FeatureIcon icon={<Stop/>} label='No servers required'></FeatureIcon></li>
                        <li><FeatureIcon icon={<Zap/>} label='Instant setup'></FeatureIcon></li>
                        <li><FeatureIcon icon={<Puzzle_piece/>} label='Drop-in library'></FeatureIcon></li>
                      </ul>
                  </div>
                  <div className={styles.content}>
                    <div className={styles.codeExample}>
                      <div className={styles.codeHeader}>
                        <Csharp size="14px" color="currentColor" />
                        <span>csharp</span>
                      </div>
                      <pre className="cursor-text">
                        <code>
{`using Indx.Api;
var engine = new SearchEngine();

`}<span className={styles.comment}>{`// ANALYZE AND INDEX JSON`}</span>{`
FileStream fstream = File.Open("movies.json", FileMode.Open, FileAccess.Read);
engine.Init(fstream);

engine.GetField("title")!.Searchable = true;
engine.GetField("description")!.Searchable = true;

engine.Load(fstream);
engine.Index();

`}<span className={styles.comment}>{`// SEARCH`}</span>{`
var result = engine.Search(new Query("matrix", 10));`}
                        </code>
                      </pre>
                    </div>
                  </div>
              </div>
          </Base>
        </div>
    </div>
  )
}
